import { useMemo } from 'react';
import { useCreateEvaluationGradeEntryBase } from '../../../Loaders/CreateEvaluationGradeEntryBaseLoader';

enum ModalityDeliveryMode {
  PR = 'PR',
  SP = 'SP',
  OL = 'OL',
}

export default function useGetStructureType() {
  const { data } = useCreateEvaluationGradeEntryBase();
  const structureType = data?.sectionData?.StructureType_id;
  const modalityDeliveryMode = data?.sectionData?.Modality_deliveryMode;
  const structureTypeCode = data?.sectionData?.StructureType_code;

  const isOnlineDeliveryMode = useMemo(() => {
    return modalityDeliveryMode === ModalityDeliveryMode.OL;
  }, [modalityDeliveryMode]);

  const isPresencialDeliveryMode = useMemo(() => {
    return modalityDeliveryMode === ModalityDeliveryMode.PR;
  }, [modalityDeliveryMode]);

  const isSemiPresencialDeliveryMode = useMemo(() => {
    return modalityDeliveryMode === ModalityDeliveryMode.SP;
  }, [modalityDeliveryMode]);

  return {
    isOnlineDeliveryMode,
    isPresencialDeliveryMode,
    isSemiPresencialDeliveryMode,
    structureType,
    structureTypeCode,
  };
}
